import React from 'react'
import LogoTextLightSvg from '@hypotenuse/platform/src/assets/hypotenuse_logo_text_light.svg'
import LogoTextDarkSvg from '@hypotenuse/platform/src/assets/hypotenuse_logo_text_dark.svg'
import Image, { ImageProps } from 'next/image'

interface HypotenuseLogoTextProps extends Omit<ImageProps, 'src'> {
  light?: boolean
}

/**
 * Logo on the left, name on the right.
 * This component uses NextJS's Image component for optimized image loading.
 */
const HypotenuseLogoText: React.FC<HypotenuseLogoTextProps> = (props) => {
  const { light, ...rest } = props
  return (
    <Image
      src={light ? LogoTextLightSvg : LogoTextDarkSvg}
      height="32px"
      alt="Hypotenuse AI logo"
      {...rest}
    />
  )
}

export default HypotenuseLogoText
